import { useContextBridge } from "@react-three/drei";
import Experience2D from "../Experience2D";
import { Canvas } from "@react-three/fiber";
import { Modal2DContext } from "../contexts/Modal2DContext";
import { ThemeContext } from "../contexts/ThemeContext";

const Portfolio2D = () => {
	const ContextBridge = useContextBridge(Modal2DContext, ThemeContext);

    return (
		<Canvas
			shadows
			gl={{ antialias: true, powerPreference: "default"}}
			dpr={[1, 2]}
			camera={{
				fov: 75,
				near: 0.6,
				far: 105,
				position: [-19.582799098260207, -2.2668489722923706, -22.23114346577159],
				rotation: [-2.7070196293391526, -0.3792982327589357, -2.9713887779165096]
			}}
		>
			<ContextBridge>
				<Experience2D />
			</ContextBridge>
			{/* <OrbitControls />  */}
		</Canvas>
    )
}

export default Portfolio2D;